import { Tabs } from "shared/components/BaseTabs";
import type { Tab } from "shared/components/BaseTabs/types";
import { type RentalVerificationFilter } from "../helpers/rental-verification";

interface RentalVerificationFiltersProps {
  filter: RentalVerificationFilter;
  firstPage?: { waiting_count?: number };
  onChange: (filter: RentalVerificationFilter) => void;
}

export const RentalVerificationFilters = ({
  filter,
  firstPage,
  onChange
}: RentalVerificationFiltersProps) => {
  const waitingCount = firstPage?.waiting_count ?? 0;

  const tabs: Tab<RentalVerificationFilter>[] = [
    { value: "all", label: "All" },
    {
      value: "waiting",
      label: "Waiting on you",
      ...(waitingCount
        ? { rightElement: { type: "counter" as const, count: waitingCount } }
        : {})
    },
    { value: "closed", label: "Closed" }
  ];

  return (
    <Tabs<RentalVerificationFilter>
      size="sm"
      tabStyle="outline"
      fullWidthTabs={false}
      className="w-fit"
      tabs={tabs}
      active={filter}
      onChange={onChange}
    />
  );
};
